import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import AlertDialog from "../../components/AlertDialog.js";
import checkImg from "../../assets/icons/check_circle.png";
import { TENANT_CLIENT_LIST_QUERY } from "../../graphQL/client_qry";
import { CLIENT_GROUP_LIST_QUERY } from "../../graphQL/group_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));
const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AssignGroupGialog({ closeDialog, onDone, preSelectedGroups, preSelectedGroupsByClient }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      group: [],
    },
  });
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [clientName, setClientName] = useState("");
  const [clientId, setClientId] = useState(1);
  const [clientOptions, setClientOptions] = useState([]);
  const [clientGroups, setClientGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState(preSelectedGroups);
  const [selectedGroupsByClient, setSelectedGroupsByClient] = useState(preSelectedGroupsByClient);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [lightBackgrndClr, setLightBackgrndClr] = useState(true);
  const PopperMy = function (props) {
    return <Popper {...props} style={styles.popper} placement="bottom-start" />;
  };
  let tenantId = 1;
  if (localStorage.getItem("tenantId")) tenantId = localStorage.getItem("tenantId");
  const [fetchTenantClientList] = useManualQuery(TENANT_CLIENT_LIST_QUERY, {
    fetchPolicy: "network-only",
  });
  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  useEffect(() => {
    (async () => fillClientDropDown())();
  }, []);

  const fillClientDropDown = async () => {
    const {
      loading: loadingClient,
      error: errorClient,
      data: dataClient,
    } = await fetchTenantClientList();
    if (dataClient && dataClient.tenantClientList) {
      let clientList = [];
      dataClient.tenantClientList.forEach((client, index) => {
        clientList.push({ label: client.name, id: client.clientId });
        if (index == 0) {
          setClientName(client.name);
          getClientGroups(client.clientId);
        }
      });
      setClientOptions(clientList);
    }
    if (errorClient) console.log(errorClient);
  };
  
  const handleChangeValue = event => {
    setClientName(event.target.value);
    let currOpt = findAnd.returnFound(clientOptions, {
      label: event.target.value,
    });
    if (currOpt === undefined) return;
    getClientGroups(currOpt.id);
  };
  
  const [getAllClientGroups] = useManualQuery(CLIENT_GROUP_LIST_QUERY, {
    fetchPolicy: "network-only",
  });
  const getClientGroups = async (selectedClientId) => {
    // Get client groups
    
    const {
      loading: clientDataLoading,
      error: clientDataError,
      data: clientData,
    } = await getAllClientGroups({
        variables: {
          clientId: parseInt(selectedClientId),
        },
      });

    if (!clientDataLoading && clientData && clientData.getAllClientGroups) {
      if(clientData.getAllClientGroups.length > 0){
        let groupList = clientData.getAllClientGroups.map(item => ({
          ...item,
          checked: false,
        }));
        
        setClientGroups(groupList);
      }
      else
        setClientGroups([]);
    }
    if (clientDataError) {
      console.log(clientDataError);
      if (
        clientDataError.graphQLErrors &&
        clientDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  const onSubmit = () => { 
    //remove clients that has not any groups of them assigned to staff
    const filteredState = Object.fromEntries(
          Object.entries(selectedGroupsByClient).filter(([key, value]) => {
          return !(Array.isArray(value) && value.length === 0);
          })
        );  
    onDone(selectedGroups,filteredState);
    handleClose();
  };
  
const columns = [
    {
      field: "name",
      headerName: "Group Name",
      headerClassName: "super-app-theme--header",
      minWidth: 170,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "select",
      headerClassName: "super-app-theme--header",
      headerName: "Select",
      minWidth: 70,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Checkbox
            onChange={() => handleCheckboxChange(rows.row.id,rows.row.name)}
            id={rows.row.id}
            defaultChecked={rows.row.checked}
          />
        );
      },
    },
  ];

  const rows = clientGroups
    .map((grp, index) => ({
      index,
      id: grp.groupId,
      name: grp.name,
      checked: selectedGroups.includes(grp.groupId),
    }));
    
  const handleCheckboxChange = (groupId,groupName) => {
    setSelectedGroups((prevSelected) =>
      prevSelected.includes(groupId)
        ? prevSelected.filter((id) => id !== groupId)
        : [...prevSelected, groupId]
    );
    setSelectedGroupsByClient((prev) => {
      const currentGroups = prev[clientName] || [];
      
      const updatedGroups = currentGroups.includes(groupName)
        ? currentGroups.filter((name) => name !== groupName)
        : [...currentGroups, groupName];

      
      return {
                  ...prev,
                  [clientName]: updatedGroups
              };
    });
  };

  return (
    <div>
      <Dialog
        disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "600px",
              height: "600px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box mt={1} ml={1}>
            Assign Groups
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent>
          <Box mb={2}>
            <Typography variant="h3" style={{ fontSize: 16 }}>
              Assign new staff to client groups
            </Typography>
          </Box>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <DialogContentText id="alert-dialog-description">
                <Box className={classes.box} style={{ textAlign: 'left' }}>
                  <InputLabel id="client-label" ml={5}>Client</InputLabel>
                  <Select
                        value={clientName}
                        labelId="client-label"
                        onChange={handleChangeValue}
                        disableUnderline
                        sx={{
                          fontSize: 16,
                          paddingRight: 1.5,
                          paddingLeft: 1.5,
                          borderRadius: "8px",
                          marginBottom: "15px"
                        }}
                  >
                        {clientOptions.map(client => (
                          <MenuItem key={client.id} value={client.label}>
                            {client.label}
                          </MenuItem>
                        ))}
                  </Select>
                  <DataGrid
                    className={classes.dataGridStyle}
                    columns={columns}
                    rows={rows}
                    showCellRightBorder={true}
                    hideFooter={true}
                    autoWidth={true}
                    getRowId={row => row.id}
                    getRowClassName={params => {
                      if (params.row.index % 2 === 0) return "even";
                      else return "odd";
                    }}
                    autoHeight={true}
                    experimentalFeatures={{ newEditingApi: true }}
                  />
                </Box>
              </DialogContentText>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={handleSubmit(onSubmit)}
            >
              Done
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
